import { type QuoteData } from "~/domains/orders/types/modelsV2";
import { ORDER_DATA_SORT_HANDLERS } from "~/features/orders/orderList/components/OrderListTable/orderDataSorting";
import { type DocumentListRow } from "~/features/orders/orderList/useOrderListState";

export enum QuoteDataSort {
  OrderAttainment = "attainment",
}

export const QUOTE_DATA_SORT_HANDLERS: Dict<(a: DocumentListRow<QuoteData>, b: DocumentListRow<QuoteData>) => number> =
  {
    ...ORDER_DATA_SORT_HANDLERS,
    [QuoteDataSort.OrderAttainment]: (a, b) => a.data.orderAttainment.localeCompare(b.data.orderAttainment),
  };
